import { normalizeMinutes } from "../../../lib/flightTimingUtils";

export function formatSignedDurationDelta(deltaMinutes) {
    const minutes = normalizeMinutes(deltaMinutes);
    if (minutes === null || minutes === 0) {
        return null;
    }

    const sign = minutes > 0 ? "+" : "-";
    const absoluteMinutes = Math.abs(minutes);
    const hours = Math.floor(absoluteMinutes / 60);
    const mins = absoluteMinutes % 60;
    return `${sign}${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
}
